import { Link } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import PageHero from "@/components/site/PageHero";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/lib/i18n";

export default function Login() {
  const { t, path } = useI18n();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <SiteLayout>
      <PageHero eyebrow={t.login.eyebrow} title={t.login.title} titleItalic={t.login.titleItalic} description={t.login.description} />

      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-container px-6 lg:px-10">
          <div className="mx-auto max-w-md">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-sm text-muted-foreground">{t.login.email}</Label>
                <Input id="email" type="email" placeholder={t.login.placeholder} autoComplete="email" required />
              </div>

              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <Label htmlFor="password" className="text-sm text-muted-foreground">{t.login.password}</Label>
                  <button type="button" className="text-xs text-muted-foreground hover:text-foreground transition-colors">{t.login.forgot}</button>
                </div>
                <Input id="password" type="password" placeholder="••••••••" autoComplete="current-password" required />
              </div>

              <Button type="submit" className="w-full" size="lg">{t.login.submit}</Button>

              <p className="text-center text-sm text-muted-foreground">
                {t.login.noAccount}{" "}
                <Link to={path("contact")} className="text-foreground underline underline-offset-4 hover:text-primary transition-colors">
                  {t.login.demo}
                </Link>
              </p>
            </form>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
